export function splitText(text, textMaxLength, checkType = true) {
  if (!checkType && text.length > textMaxLength) {
    return `${text.split('.')[0].slice(0, textMaxLength)}...`
  }

  const type = text.split('.').pop()
  if (text.length - (type ? type.length : 0) >= textMaxLength) {
    return `${text.split('.')[0].slice(0, textMaxLength)}....${type}`
  }
  return text
}
export function shortText(text = '', textMaxLength) {
  if (text.length > textMaxLength) {
    return `${text.slice(0, textMaxLength)}...`
  }
  return text
}
export function maxTextLengthInTable() {
  return 110
}

function decimalAdjust(type, value, exp) {
  // Если степень не определена, либо равна нулю...
  if (typeof exp === "undefined" || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // Если значение не является числом, либо степень не является целым числом...
  if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
    return NaN;
  }
  // Сдвиг разрядов
  value = value.toString().split("e");
  value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
  // Обратный сдвиг
  value = value.toString().split("e");
  return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
}

export function round10 (value, exp) {
  return decimalAdjust("round", value, exp);
}
